import { useDispatch } from "react-redux";
import { AppThunkDispatch } from "../store";

export const useAppThunkDispatch = () =>
  useDispatch<AppThunkDispatch>();
